export default {"src":"/_next/static/media/level.93763043.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};